









































































































































import {
  Component,
  Prop,
  Vue,
  Watch,
  Mixins,
  InjectReactive
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { ProductChildren, channelAttributeParse } from "@root/lib/mixins";
import { FormVaildateToOut } from "@root/lib/decorator";
import channelAttrItem from "@/components/pages/ProductCreate/channelComponents/channelAttrItem.vue";
import channelEditSkuDialog from "@/components/pages/ProductCreate/channelComponents/channelEditSkuDialog.vue";
const productCreate = namespace("productCreate");
@Component({ components: { channelAttrItem, channelEditSkuDialog } })
// @FormVaildateToOut("form", {
//   resCbName: "resFormart"
// })
export default class channelSkuBLock extends Mixins(
  ProductChildren,
  channelAttributeParse
) {
  // @InjectReactive("curChannel") curChannel;
  @Prop({ default: false }) disabled;
  @Prop({ default: [] }) channelSkuList;
  @Prop({ default: false }) loading;
  @productCreate.Getter skuList: any[];
  @productCreate.Action saveConnSkuList;
  // 打开编辑 sku 弹出层
  curEditSkuIndex: any = "";
  publishSelection = [];
  get channelSkuMapMaster() {
    let map = {};
    this.skuList.forEach(_ => {
      let list = this.channelSkuList.filter(item => item.skuCode === _.skuCode);
      if (list && list.length > 0) {
        this.$set(map, _.skuCode, list[0].channelSkuCode);
      } else {
        this.$set(map, _.skuCode, "");
      }
    });
    return map;
  }
  openEditskuDialog(skuItem, index) {
    this.curEditSku = {
      ...this.ruleForm.skuList[skuItem.skuCode],
      channelSkuCode: this.channelSkuMapMaster[skuItem.skuCode] || ""
    };
    this.curEditSkuIndex = index;
    (this.$refs.channelEditSkuDialog as any).visible = true;
    console.log(skuItem, index, 99);
  }
  curEditSku = {};

  // 提交表单
  resFormartData(skuItem) {
    console.log("resFormart", this.ruleForm, this.rules);
    let result = [];
    // this.skuList.forEach((_, index) => {
    let skuItemForm = this.handleResetFormItem(skuItem);
    result.push({
      skuCode: this.skuList[this.curEditSkuIndex].skuCode,
      shopCode: this.curChannel.value,
      channelAttrValue: skuItemForm
    });
    // });
    return result;
  }
  // 结构渲染列表数据监听
  @Watch("blockList", { immediate: true, deep: true })
  watchBlockList(blockList) {
    if (blockList && blockList.length > 0) {
      this.$set(this.ruleForm, "skuList", {});
      let form = {};
      this.skuList.forEach((_, index) => {
        this.initBlock(blockList, form, this.data[_.skuCode] || {});
        this.$set(this.ruleForm.skuList, _.skuCode, { ...form });
      });
    }
  }
  async editSkuConfirm(form) {
    let param = this.resFormartData(form);
    await this.saveConnSkuList({ input: param });

    (this.$refs.channelEditSkuDialog as any).visible = false;
    let message: any = this.$t("Basic.success");
    this["$message"].success(message);
    this.$emit("saveSkuSuccess");
  }
  // sku 是否可以发布
  filterIsDisabled(row, index) {
    return !!this.data[row.skuCode];
  }
  getRowKeys(row) {
    return row.skuCode;
  }
  // 选择要发布的sku
  handleSelectionChange(val) {
    this.publishSelection = val;
  }
  // 发布sku
  publishSku() {
    console.log(this.publishSelection);
  }
}
